export const API_URL = "https://rscoreapi.azurewebsites.net/api/"